import View from './view.js';
import icons from 'url:../../img/icons.svg';
import previewView from './previewView.js';

// ///////////////////////////////////////
class BookMarkView extends View {
  _parentElement = document.querySelector('.bookmarks__list');
  _errMessage = 'No bookmark yet. Find a nice recipe and bookmark it;)';
  _successMessage = '';

  addHandlerRender(handler) {
    window.addEventListener('load', handler);
  }
  _generateMarkup() {
    return this._data
      .map(bookmark => previewView.render(bookmark, false))
      .join('');
  }
}

export default new BookMarkView();
